import { combineReducers } from '@reduxjs/toolkit';
import { listSlice } from './listSlice';
import { registrationSlice } from './registrationSlice';
import { detailSlice } from './detailSlice';

export const crawlerReducer = combineReducers({
  list: listSlice.reducer,
  registration: registrationSlice.reducer,
  detail: detailSlice.reducer,
});
